import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import * as MUI from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetTiers } from "../../../../hooks/useGetTiers";

function TierMenuButton({ count, disabled, onSelect }) {
  const { t } = useTranslation();
  const { data: tiers } = useGetTiers();
  const [anchor, setAnchor] = useState(null);

  function handleSelect(tier) {
    setAnchor(null);
    onSelect(tier);
  }

  return (
    <>
      <MUI.Button
        variant="contained"
        color="info"
        size="small"
        endIcon={<ArrowDropDownIcon />}
        disabled={disabled}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        {t("ChangeTierSelectedClinics", { count })}
      </MUI.Button>
      <MUI.Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
      >
        {(tiers ?? []).map((tier) => (
          <MUI.MenuItem key={tier.id} onClick={() => handleSelect(tier)}>
            {t(tier.title)}
          </MUI.MenuItem>
        ))}
      </MUI.Menu>
    </>
  );
}

export default function ClinicBulkActions({
  showImport,
  counts,
  busy,
  onSelectAll,
  onDeselectAll,
  onImport,
  onActivate,
  onDeactivate,
  onChangeTier,
}) {
  const { t } = useTranslation();
  return (
    <MUI.Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      <MUI.Button variant="outlined" size="small" onClick={onSelectAll}>
        {t("SelectAll")}
      </MUI.Button>
      <MUI.Button variant="outlined" size="small" onClick={onDeselectAll}>
        {t("DeselectAll")}
      </MUI.Button>
      {showImport && (
        <MUI.Button
          variant="contained"
          size="small"
          disabled={counts.import === 0 || busy.import}
          onClick={onImport}
        >
          {t("ImportSelectedClinics", { count: counts.import })}
        </MUI.Button>
      )}
      <MUI.Button
        variant="contained"
        color="success"
        size="small"
        disabled={counts.activate === 0 || busy.activate}
        onClick={onActivate}
      >
        {t("ActivateSelectedClinics", { count: counts.activate })}
      </MUI.Button>
      <MUI.Button
        variant="contained"
        color="error"
        size="small"
        disabled={counts.deactivate === 0 || busy.deactivate}
        onClick={onDeactivate}
      >
        {t("DeactivateSelectedClinics", { count: counts.deactivate })}
      </MUI.Button>
      <TierMenuButton
        count={counts.changeTier}
        disabled={counts.changeTier === 0 || busy.changeTier}
        onSelect={onChangeTier}
      />
    </MUI.Stack>
  );
}
